export const VDS_FONT_FAMILY =
  '"Pretendard Variable", Pretendard, "Malgun gothic", "맑은 고딕", -apple-system, BlinkMacSystemFont, helvetica, "apple SD Gothic Neo", sans-serif';
